export default "__VITE_PUBLIC_ASSET__d9e2fc0a__"